<template>
    <svg id="UNDERLINE" xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 47.807 17.222">
        <path id="Path_28" data-name="Path 28" d="M749.98,345.727a107.906,107.906,0,0,1,21.312-7.538,100.437,100.437,0,0,1,11.479-2c1.916-.22,3.841-.38,5.765-.524a25.626,25.626,0,0,0,5.765-.649.97.97,0,0,0-.091-1.851,18.261,18.261,0,0,0-6.061-.473c-1.93.03-3.853.171-5.774.364a89.438,89.438,0,0,0-11.867,2.022,98.652,98.652,0,0,0-21.757,8.1c-1.427.725-.24,3.25,1.229,2.556Z" transform="matrix(0.996, 0.087, -0.087, 0.996, -715.118, -396.592)" :fill="fillColor"/>
    </svg>
</template>
<script>
export default {
    name: 'Underline',
    props: {
        width: {
            type: [Number, String],
            default: '47.807px',
        },
        height: {
            type: [Number, String],
            default: '17.222px',
        },
        fillColor: {
            type: String,
            default: '#191919',
        },
    },
};
</script>
